import React from "react";
import PropTypes from "prop-types";

import ExpenseLineForm from "./ExpenseLineForm";

const ExpenseFormRow = ({
  row,
  adding,
  editing,
  index,
  isTerminal,
  removeDisabled,
  removeExpenseRow,
  addExpenseRow,
  generateCodeOptions,
  addNewReceipt,
  codes,
  expense,
  auth
}) => (
  <React.Fragment>
    {adding && <div style={{ textAlign: "center" }}>Expense</div>}
    <ExpenseLineForm
      expense={expense}
      row={row}
      id={row.id}
      index={index}
      generateCodeOptions={generateCodeOptions}
      editing={editing}
      adding={adding}
      uploadReceipt={addNewReceipt}
      file={row.receipt}
      codes={codes}
      auth={auth}
    />
    {adding && (
      <React.Fragment>
        <div style={{ textAlign: "right" }}>
          {isTerminal && (
            <button
              className="btn-sm"
              type="button"
              onClick={addExpenseRow}
              style={{
                background: "#50accb",
                color: "#fff",
                border: "none"
              }}
            >
              Create Another Expense
            </button>
          )}
          <button
            className="btn-sm"
            type="button"
            disabled={removeDisabled}
            onClick={() => removeExpenseRow(row.id)}
            style={{
              marginLeft: "10px",
              background: removeDisabled ? "#FE9773" : "#fe703f",
              color: "#fff",
              border: "none",
              cursor: removeDisabled ? "not-allowed" : "pointer"
            }}
          >
            Remove Expense
          </button>
        </div>
        <hr />
      </React.Fragment>
    )}
  </React.Fragment>
);

ExpenseFormRow.propTypes = {
  row: PropTypes.object,
  adding: PropTypes.bool,
  editing: PropTypes.bool,
  index: PropTypes.number,
  removeDisabled: PropTypes.bool,
  removeExpenseRow: PropTypes.func,
  addExpenseRow: PropTypes.func,
  isTerminal: PropTypes.bool,
  generateCodeOptions: PropTypes.func,
  addNewReceipt: PropTypes.func,
  codes: PropTypes.array,
  expense: PropTypes.object
};
export default ExpenseFormRow;
